import { Component, Input } from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';

@Component({
	selector: 'vg-skip-chapter',
	template: `
		<button
			type="button"
			class="button vb-icon vb-icon-skip"
			[attr.aria-label]="translations.nextChapter"
			[tooltip]="translations.nextChapter"
			[placement]="'top'"
			[disabled]="vgApi.chaptersButtonDisabledSignal()"
			(click)="vgApi.nextChapter()">
		</button>
	`,
	standalone: false,
	styleUrls: ['./VgSkipChapter.Component.ng.less']
})
export class VgSkipChapterComponent {
	@Input() public translations: any;

	constructor(
		public vgApi: VideogularComponent
	) { }


}
